import script from "./temp1.vue?vue&type=script&setup=true&lang=js"
export * from "./temp1.vue?vue&type=script&setup=true&lang=js"

import "./temp1.vue?vue&type=style&index=0&id=67dbb76a&lang=less"

const __exports__ = script;

export default __exports__